import globalStyle from "@store/theme/common/styleguide/globalStyle";
import mergeProps from "@store/utilities/mergeProps";

export default mergeProps(globalStyle, {});
